import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToFirstError()
    
    this.element.addEventListener("turbo:frame-render", this.scrollToFirstError.bind(this))
    
    document.addEventListener("turbo:load", this.scrollToFirstError.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-render", this.scrollToFirstError.bind(this))
    document.removeEventListener("turbo:load", this.scrollToFirstError.bind(this))
  }

  scrollToFirstError() {
    setTimeout(() => {
      const firstErrorMessage = this.element.querySelector('.text-red-600')
      
      if (firstErrorMessage) {
        const errorWrapper = firstErrorMessage.closest('.mb-4, .mb-0')
        
        let input = null
        
        if (errorWrapper) {
          input = errorWrapper.querySelector('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), select, textarea')
          
          if (!input) {
            const label = errorWrapper.querySelector('label')
            if (label && label.getAttribute('for')) {
              const inputId = label.getAttribute('for')
              input = this.element.querySelector(`#${inputId}`)
            }
          }
        }
        
        if (!input) {
          let current = firstErrorMessage.parentElement
          let depth = 0
          while (current && depth < 5) {
            const foundInput = current.querySelector('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), select, textarea')
            if (foundInput) {
              input = foundInput
              break
            }
            current = current.parentElement
            depth++
          }
        }
        
        const scrollTarget = input || errorWrapper || firstErrorMessage.closest('div') || firstErrorMessage
        
        if (scrollTarget) {
          scrollTarget.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center',
            inline: 'nearest'
          })

          if (input && typeof input.focus === 'function') {
            setTimeout(() => {
              try {
                input.focus()
              } catch (e) {
              }
            }, 400)
          }
        }
      }
    }, 150)
  }
}
